import * as XLSX from "xlsx";
import Sheet from "./Sheet";

export default class Workbook {
    constructor(raw) {

        this.raw = raw;

        /** @type {Sheet[]} */
        this.sheets = [];


        const sheetNames = raw.SheetNames;
    
        for(const sheetName of sheetNames) {
            const rawSheet = raw.Sheets[sheetName];
            const sheet = new Sheet(rawSheet);
            this.sheets.push(sheet);
        }
    }

    static fromPath(path) {
        const wb = XLSX.readFile(path);
        return new Workbook(wb);
    }

    /**
     * 
     * @param {*} file 
     * @returns {Promise<Workbook>}
     */
    static fromFile(file) {
        return new Promise(resolve => {
            const reader = new FileReader();
            reader.onload = event => {
                const binary = event.target.result;
                const wb = XLSX.read(binary, { type: "binary" });
                resolve(new Workbook(wb));
            };

            reader.readAsBinaryString(file);
        });
    }
}
